import { TrendingUp } from "lucide-react";

const CALLS = [
  { ticker: "$PEPE2", x: "420X", t: "2h ago" },
  { ticker: "$BOME", x: "512X", t: "5h ago" },
  { ticker: "$BONK", x: "180X", t: "1d ago" },
  { ticker: "$WIF", x: "96X", t: "1d ago" },
  { ticker: "$POPCAT", x: "233X", t: "2d ago" },
  { ticker: "$MEW", x: "74X", t: "3d ago" },
  { ticker: "$SLERF", x: "310X", t: "4d ago" },
  { ticker: "$GIGA", x: "158X", t: "5d ago" },
];

export const Marquee = () => {
  const row = [...CALLS, ...CALLS];
  return (
    <div
      data-testid="gains-marquee"
      className="relative border-y border-[#14f19522] bg-[#0A0D14] py-4 overflow-hidden"
    >
      <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-[#0A0D14] to-transparent" />
      <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-[#0A0D14] to-transparent" />
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((c, i) => (
          <div key={i} className="flex items-center gap-3 shrink-0">
            <TrendingUp className="w-4 h-4 text-[#14F195]" />
            <span className="font-display font-bold text-white">{c.ticker}</span>
            <span className="font-mono font-bold text-[#14F195] text-glow-green">{c.x}</span>
            <span className="font-mono text-xs text-[#64748B]">{c.t}</span>
            <span className="text-[#14312a]">/</span>
          </div>
        ))}
      </div>
    </div>
  );
};
